module.exports = __webpack_public_path__ + "static/media/TrashSimple.fcc48739.svg";